/**
 * Resolves media URLs for listings, avatars, and attachments.
 * Normalizes legacy `/api/v1/uploads/` paths to `/uploads/` to ensure
 * reliable delivery through Nginx without regex collisions.
 */
export function resolveMediaUrl(url?: string | null): string {
  if (!url) return ''
  if (url.startsWith('/api/v1/uploads/')) {
    return url.replace('/api/v1/uploads/', '/uploads/')
  }
  return url
}

/** Per-file size limit of `POST /uploads` (`UploadController.maxFileSize`), for images and attachments alike. */
export const MAX_UPLOAD_BYTES = 4 * 1024 * 1024
/** `MAX_UPLOAD_BYTES` as shown in the UI. */
export const MAX_UPLOAD_LABEL = '4 MB'
/** Listing images and avatars (`RequestValidation.imageExtensions`). Attachments may also be GIF. */
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp']

export interface MessageAttachment {
  url: string
  type: 'image' | 'file'
  name?: string
}

const IMAGE_EXTENSION = /\.(?:jpe?g|png|gif|webp)$/i

/** Describes a stored upload path as a chat attachment, guessing image vs file from its extension. */
export function attachmentFromUrl(url: string): MessageAttachment {
  const name = url.split(/[?#]/)[0]!.split('/').pop() ?? ''
  return { url, type: IMAGE_EXTENSION.test(name) ? 'image' : 'file', name: name || undefined }
}
